import axios from "axios";
import Qs from "qs";
import { Message } from "element-ui";
import constant from "@/common/constant";
import AccessUtil from "@/common/AccessUtil";
// import { error } from "console";

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.post["Access-Control-Allow-Credentials"] = true;

let service = axios.create({
  // baseURL: 'http://172.16.20.46:7660',
  // baseURL: '172.16.20.96:7660'
  // baseURL:'https://gzszxcpreserver.xiaoheitech.cn',
  // || process.env.NODE_ENV == 'test'
  // baseURL: `http://172.16.40.37:7660`,
  baseURL:
    process.env.NODE_ENV == "development"
      ? `//${process.env.VUE_APP_VIZEN_API}`
      : process.env.NODE_ENV == "test"
        ? `https://${process.env.VUE_APP_VIZEN_API}`
        : `https://${process.env.VUE_APP_VIZEN_API_pro}`,
  // transformRequest: [function (data) {
  //     return Qs.stringify({...dat\a})
  // }]
  // timeout: 150000
  timeout: 600000,
});

let loadingContainer = null;
let needLoadingRequestCount = 0;

function startLoading() {
  // console.log(`${location.protocol}//${process.env.VUE_APP_VIZEN_API}`)
  let barElement1 = document.createElement("div");
  barElement1.setAttribute("class", "bar");

  let barElement2 = document.createElement("div");
  barElement2.setAttribute("class", "bar");

  let barElement3 = document.createElement("div");
  barElement3.setAttribute("class", "bar");

  let loadingElement = document.createElement("div");
  loadingElement.setAttribute("class", "loading");
  loadingElement.appendChild(barElement1);
  loadingElement.appendChild(barElement2);
  loadingElement.appendChild(barElement3);

  loadingContainer = document.createElement("div");
  loadingContainer.setAttribute("class", "loading-container");
  loadingContainer.appendChild(loadingElement);

  document.body.appendChild(loadingContainer);
}

function closeLoading() {
  document.body.removeChild(loadingContainer);

  loadingContainer = null;
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }

  needLoadingRequestCount++;
}

function hideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) {
    return;
  }

  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    closeLoading();
  }
}

service.interceptors.request.use(
  function (config) {
    if (config.loading) showFullScreenLoading();
    if (AccessUtil.getAuthToken() != null) {
      config.headers["Auth-Token"] = AccessUtil.getAuthToken();
    }

    // config.headers["Auth-Token"] = 'hujE5Vh+HcX8UnwdAzrLf5+DrWG/FgIcB4M1qzIES1QmuVf1IDl6hyDHhfi/N1gc5rWI+N4mTHAHK44FtB8S/CWkaWUVoZn4iXhj3mX3fwFO6p7RRAGA8QPvTLmQzj63FoYL3yUbcG1ouQAvvw78kVPARG007pJaDDJLDbE92W4=';

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  function (response) {
    hideFullScreenLoading();
    if (response.data == null) {
      return Promise.reject("Null response");
    }

    if (
      (response.data.status && response.data.status == "10001") ||
      (response.data.code && response.data.code == "10001")
    ) {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      let reg = new RegExp("/$"); // eslint-disable-line
      if (reg.test(process.env.VUE_APP_BASE_URL)) {
        baseUrl = process.env.VUE_APP_BASE_URL.substring(
          0,
          process.env.VUE_APP_BASE_URL.length - 1,
        );
      }
      location.href = baseUrl + "/login";
    } else if (response.data.code == 403) {
      Message({
        message: response.data.msg,
        type: "warning",
        duration: 5 * 1000,
      });
      return false;
    } else if (response.data.code == 0) {
      // Message({
      //     message: response.data.msg,
      //     type: "warning",
      //     duration: 5 * 1000
      // });
      // return false;
      return response.data;
    } else if (response.data.code == 400) {
      // Message({
      //     message: response.data.msg,
      //     type: "warning",
      //     duration: 5 * 1000
      // });
      // return false;
      return response.data;
    } else if (
      response.data.code == 1 ||
      response.data.status == 0 ||
      response.data.code == 2 ||
      response.data.code == 0 ||
      response.data.code == 1000
    ) {
      return response.data;
    } else if (!response.data.code) {
      // let url = window.URL.createObjectURL(new Blob([response]));
      // let link = document.createElement('a');
      // link.style.display = 'none';
      // link.href = url;
      // link.setAttribute('download', 'tmp');
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // window.location.href = newHref
      return response;
    } else if (response.data.code == 500) {
      Message({
        message: response.data.msg,
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject("未知错误");
    } else if (response.data.status == 1) {
      Message({
        message: response.data.msg,
        type: "warning",
        duration: 5 * 1000,
      });
      return Promise.reject("未知错误");
    } else {
      return Promise.reject("未知错误");
    }
  },
  function (error) {
    hideFullScreenLoading();

    Message({
      message: error.message,
      type: "warning",
      duration: 5 * 1000,
    });

    return Promise.reject(error);
  },
);

export default {
  get(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      // if(!type) {
      //     param = Qs.stringify(param);
      // }
      // console.log(data)
      service({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "get",
        url,
        params: param,
        data: data,
        loading: loading,
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get2(url, param, type, loading = true) {
    return new Promise((resolve, reject) => {
      // if(!type) {
      //     param = Qs.stringify(param);
      // }
      service({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "get",
        url,
        loading: loading,
        params: {
          [type]: param,
        },
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status && response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get3(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params: param,
        loading: loading,
        headers: {
          "Content-Type": "application/json",
        },
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status && response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get4(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      // if(!type) {
      //     param = Qs.stringify(param);
      // }
      // console.log(data)
      // data = Qs.stringify(data);

      // let ajaxData = Qs.stringify({
      //     file : data
      // });
      service({
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=<calculated when request is sent>",
        },
        method: "get",
        url,
        params: param,
        loading: loading,
        data: data,
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      data = Qs.stringify(data);
      service({
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "post",
        url,
        params: param,
        data: data,
        crossDomain: true,
        loading: loading,
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post2(url, param, data, type, loading = true) {
    return new Promise((resolve, reject) => {
      // const formData = new FormData();
      // var str = JSON.stringify(data);
      // formData.append(type, data);
      // data = formData;
      data = JSON.stringify(data);
      console.log(type);
      let ajaxData = Qs.stringify({
        [type]: data,
      });
      console.warn("ajaxData: ", ajaxData);
      service({
        method: "post",
        url,
        params: param,
        data: ajaxData,
        crossDomain: true,
        loading: loading,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post3(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      // data = Qs.stringify(data);
      service({
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        url,
        params: param,
        crossDomain: true,
        loading: loading,
        // responseType: "arraybuffer",
        data: JSON.stringify(data),
        // xhrFields: {
        //     withCredentials: true
        // },
        // responseType: 'blob',
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post4(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      data = Qs.stringify(data);
      service({
        headers: {
          "Content-Type": "multipart/form-data",
        },
        method: "post",
        url,
        params: param,
        data: data,
        crossDomain: true,
        loading: loading,
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post5(url, data, loading = true) {
    return new Promise((resolve, reject) => {
      // data = Qs.stringify(data);
      service({
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        url,
        crossDomain: true,
        loading: loading,
        // responseType: "arraybuffer",
        data,

        // xhrFields: {
        //     withCredentials: true
        // },
        // responseType: 'blob',
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post6(url, param, data, loading) {
    console.log(data);
    return new Promise((resolve, reject) => {
      service({
        headers: {
          "Content-Type": "application/json",
        },
        method: "post",
        url,
        params: param,
        data: data,
        crossDomain: true,
        loading: loading,
        // cancelToken: source.token
      })
        .then((response) => {
          if (response.status == "10001") {
            let baseUrl = process.env.VUE_APP_BASE_URL;
            let reg = new RegExp("/$"); // eslint-disable-line
            if (reg.test(process.env.VUE_APP_BASE_URL)) {
              baseUrl = process.env.VUE_APP_BASE_URL.substring(
                0,
                process.env.VUE_APP_BASE_URL.length - 1,
              );
            }
            location.href = baseUrl + "/login";
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  put(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      service({
        method: "put",
        url,
        params: param,
        data: data,
        loading: loading,
        cancelToken: source.token,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      service({
        method: "delete",
        url,
        params: param,
        data: data,
        cancelToken: source.token,
        loading: loading,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  upload(url, param, data, loading = true) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        params: param,
        data: data,
        crossDomain: true,
        loading: loading,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // cancelToken: source.token
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  down(url, param, loading) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        params: param,
        crossDomain: true,
        responseType: "blob",
        loading: loading,
      })
        .then((response) => {
          console.error(axios.defaults.baseUrl);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  blob(url, data) {
    return new Promise((resolve) => {
      service({
        method: "get",
        url: url,
        params: data,
        responseType: "blob",
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
